/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ReportHistory.css';
import ReactEcharts from 'echarts-for-react'
import moment from 'moment'

class ReportHistory extends React.Component {

  constructor(props) {
    super(props)
    this.state = {}
    this.getOption = this
      .getOption
      .bind(this)
  }

  getOption = () => {

    const data1 = this.props.json


    let timeArr = []
    const len=data1.length

    for (let i = 0; i < data1.length; i++) {
      timeArr.unshift(moment(this.props.endTime).subtract(i, 'days').format('YYYY.MM.DD'))
    }
    let chartsJson=[]
    
    for(let i in data1){
      let barData=
        {

          name: 'DB总值',
          type: 'bar',
          value:data1[i],
          itemStyle: {
            normal:{
              color: this.props.color
            }
          },
          label: {
            normal: {
              show: this.props.showLabel,
              position:data1[i]>=0?'top':'bottom',
              color: '#000',
              fontWeight: 'bold'
            }
          },
        }
    chartsJson.push(barData)
    
    }
    

 

    const option = {
      title: {
        text: this.props.tit,
        subtext: `时间窗口：${moment(this.props.startTime).format('YYYY.MM.DD') } - ${moment(this.props.endTime).format('YYYY.MM.DD')}`,
        // sublink:'',
        x: '20'
      },
      color: [
        '#c2e1c5', '#fac8a7', '#abd9f2', '#f1b1ad'
      ],
      legend: {
        show: false,
        data: [
          '微信', '微博', '知乎', '今日头条', 'DB总值'
        ],
        align: 'left'
      },
      toolbox: {
        right: 20,
        show: true,
        feature: {
          dataView:{
            show:true
          },
          restore: {
            show: true
          },
          saveAsImage: {
            show: true
          }
        }
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      xAxis: {
        data: timeArr,
        type: 'category',
        silent: false,
        splitLine: {
          show: false
        }
      },
      yAxis: [
        {
          type: 'value',
          // boundaryGap: [0.2, 0.2]
        }

      ],
      series: [
        {
          name: 'DB总值',
          type: 'bar',
          itemStyle: {
            normal:{
              color: this.props.color
              
            }
          },
          barWidth:len>7?'0':'40',
          barMaxWidth:'40',
          label: {
            normal: {
              show: true,
              position: 'top',
              color: '#000',
              fontWeight: 'bold'
            }
          },
          data: chartsJson,
          
          // yAxisIndex:1
        }
      ],
      animationEasing: 'elasticOut',
      animationDelayUpdate: function (idx) {
        return idx * 5;
      }
    };
    return option
  }

  render() {

    // console.log(timeArr)

    return (<ReactEcharts
      option={this.getOption()}
      style={{
        height: '550px',
        width: '100%',
        borderRadius: '4px'
      }}
      className={s.charts}
      notMerge={true}
      lazyUpdate={true}
      theme={"theme_name"}
      onChartReady={this.onChartReadyCallback}/>)

  }
}

export default withStyles(s)(ReportHistory);



// WEBPACK FOOTER //
// src/components/ReportHistory/ReportHistory.js